import { FC } from 'react';
import Button from '@amzn/awsui-components-core/button';
import SpaceBetween from '@amzn/awsui-components-core/space-between';
import { useTranslate } from 'src/hooks/useTranslate';

const CAMPAIGN_ACTION_BAR_BUNDLE = 'molecules.campaignActionBar';

interface CampaignActionBarProps {
  hasSelection: boolean;
  onCreateClick: () => void;
  onModifyClick: () => void;
  onCancelClick: () => void;
}

const CampaignActionBar: FC<CampaignActionBarProps> = ({
  hasSelection,
  onCreateClick,
  onModifyClick,
  onCancelClick,
}) => {
  const { translate } = useTranslate(CAMPAIGN_ACTION_BAR_BUNDLE);

  return (
    <SpaceBetween direction="horizontal" size="xs">
      <Button variant="primary" onClick={onCreateClick}>
        {translate('create_button')}
      </Button>
      <Button disabled={!hasSelection} onClick={onModifyClick}>
        {translate('modify_button')}
      </Button>
      <Button disabled={!hasSelection} onClick={onCancelClick}>
        {translate('cancel_button')}
      </Button>
    </SpaceBetween>
  );
};

export default CampaignActionBar;
